import { makeStyles } from "@material-ui/core";
import { color } from "../../../assets/const/color";
export const useStyles = makeStyles(() => ({
    admit: {
        "& .MuiInputBase-root": {
            borderRadius: "50px",
            fontFamily: "inter !important",
          },
    "& .MuiCheckbox-colorPrimary.Mui-checked": {
      color: `${color.gray} !important`,
      borderRadius: "50px !important",
    },
    "& .MuiCheckbox-root.MuiCheckbox-indeterminate": {
      color: `${color.gray} !important`,
    },
    "& .MuiTableHead-root": {
      background: "#FEB62C",
      "& .MuiTableCell-root": {
        color: `${color.white} !important`,
        fontFamily: "inter",
      },
      "& :first-child": {
        borderRadius: "10px 0px 0px 0px !important",
      },
      "& :last-child": {
        borderRadius: "0px 10px 0px 0px !important",
      },
    },
    "& .MuiTableRow-root .MuiTableCell-root": {
      fontFamily: "inter !important",
    },
    "& .MuiPaper-root": {
      background: "#fff",
      // color:"#a9aaba",
      borderRadius: "22px",
      boxShadow: "0px 4px 14px rgb(0 0 0 / 8%)",
    },
    
  },
  add_course_text: {
    fontFamily: "inter !important",
    fontSize: "18px !important",
    fontWeight: "700 !important",
    color: "#00473E",
  },
  input_label: {
    marginRight:"20px",
  },
  label: {
    color: "#374151",
    fontFamily: "inter !important",
    fontSize: "14px !important",
    fontWeight: "500 !important",
  },
  form_add_course: {
    "& .MuiInputBase-root": {
      borderRadius: "50px",
      fontFamily: "inter !important",
    },
    "& .MuiButton-root:hover": {
      background: `${color.lightGreen} !important`,
      color: `${color.white} !important`,
    },
  },
  facultyName: {
    color:`${color.darkGreen} !important`,
    fontFamily: "inter !important",
    fontWeight: "700 !important",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    width: "100%",
    display: "block",
  },
  dept: {
    float: "right",
    color:`${color.lightGreen} !important`,
    fontFamily: "inter !important",
    fontWeight: "700 !important",
    fontSize: "12px",
    margin:"3px 0px 0px 0px",
  },
  title: {
    fontWeight: "700 !important",
    fontFamily:"public sans",
  },
  innerDesign: {
    width:"170px", height:"170px", borderRadius:"20px !important",
  },
  outerWrap: {
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
    justifyContent: "space-between",
    rowGap: "30px",
  }
}));
